import { t } from "./i18n";

export function formatAppVersion({
  desktop,
  releaseVersion,
  serverVersion,
  clientBuild,
}: {
  desktop: boolean;
  releaseVersion: string;
  serverVersion: string | null;
  clientBuild: string | null;
}) {
  if (desktop) {
    return t("common/version_55elao", { "0": releaseVersion });
  }

  const clientHash = clientBuild?.match(/^\/assets\/index-([\w-]+)\.js$/)?.[1];
  return [
    serverVersion ? t("common/version_55elao", { "0": serverVersion.slice(0, 8) }) : null,
    clientHash ? t("common/client_nvdwdu", { "0": clientHash.slice(0, 8) }) : null,
  ]
    .filter(Boolean)
    .join(" · ");
}
